export default "__VITE_ASSET__bcaefa79__"